import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

type State = "checking" | "authed" | "unauthed";

export function AdminGate({ children }: { children: ReactNode }) {
  const [state, setState] = useState<State>("checking");

  useEffect(() => {
    let cancelled = false;
    api("/admin/me").then((res) => {
      if (cancelled) return;
      setState(res.ok ? "authed" : "unauthed");
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    return (
      <div className="flex items-center justify-center p-12 text-slate-600">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }
  if (state === "unauthed") {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}
